export const getBrandCatalogues = state => state.Catalogue.catalogues;
